import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.css";
import "./App.css";
import { ToastContainer } from "react-toastify";
import {
  ActiveOrder,
  Login,
  OrdersPrepared,
  OrdersDelivered,
  Customer,
  Supplier,
  EditAddress,
  Delivery,
  SuperMarketComment,
  RestaurantComment,
  RestaurantProduct,
  SupermarketProduct,
  AdminPart,
  SupplierSupport,
  UserSupport,
  AssignProductToRestaurant,
  AssignProductToSupermarket,
  AddCustomer,
  AddSupplier,
  AddDelivery,
  AddAdmin,
  ProductRestaurantComment,
  ProductSupermarketComment,
  SuperyProducts,
  EditSuperyProduct,
  // EditDeliveryInfo,
  // EditSupplierInfo,
  // EditAdminInfo,
  OneProductDiscount,
  AllDiscountProduct,
  OneCategoryDiscount,
  CreateDiscountCode,
  OneProductDiscountList,
  AllProductDiscountList,
  OneCategoryDiscountList,
  AddNewCategory,
  LevelOneCategoryListPart,
  LevelTwoCategoryListPart,
  EditProductCategory,
  DeliverCost,
  AddBrand,
  BrandList,
  ResturansFood,
  ResturantCategoryList,
  AllOrder,
  OutCome,
  InCome,
  ActiveOrderPeyk,
  AllOrderPeyk,
  AcceptedOrderSupplierPeyk,
  OrdersPreparedPeyk,
  AcceptedOrderDeliveryPeyk,
  OrdersDeliveredPeyk,
  AddDriver,
  AddVehicle,
  VehicleList,
  AddColor,
  ColorList,
  Driver,
  EditDriver,
  EditDelivery,
  newPayRequest,
  payedRequestList,
  EditSupplier,
  EditAdmin,
  AllTaxiRequest,
  createpublicdiscountcode,
  PublicDiscountList,
  createPrivateDiscountCode,
  PrivateDiscountList,
  NotPaidOrder,
  CanceledOrder,
  DeliverySupport,
  AllDeliveryRequest,
  AddFactor,
  FactorList,
  failedPay,
  BarestHelpList,
  IntelegentVoiceOrder,
  EditProductBaseSupplier,
} from "./Pages/Index";
import AddResturantCategory from "./Pages/Layout/CategoryPart/AddResturantCategory/AddResturantCategory";
import {getTokens} from './firebase'
function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  if(!!localStorage.getItem('adminToken')){
      if(!isTokenFound){getTokens(setTokenFound);}
  }

  const isLogin = () => !!localStorage.getItem("adminToken");

  const PublicRoute = ({ component, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) {
            return <Redirect to={"/activeorderfood"} />;
          } else {
            return React.createElement(component);
          }
        }}
      />
    );
  };

  const PrivateRoute = ({ render, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) {
            return render(props);
          } else {
            return <Redirect to={"/"} />;
          }
        }}
        />
        );
      };
      return (
    <Router>
      <Switch>
        <PublicRoute exact path="/" component={Login} />
        <PrivateRoute
          path="/"
          render={() => (
            <Switch>
              {/* **********************  food part ********************** */}
              <Route path="/activeorderfood" component={ActiveOrder} />
              <Route path="/allorderfood" component={AllOrder} />
              <Route path="/notpaidorder" component={NotPaidOrder}/>
              <Route path="/preparedorderfood" component={OrdersPrepared} />
              <Route path="/canceledorder" component={CanceledOrder}/>
              <Route path="/ordersdeliveredfood" component={OrdersDelivered} />

              <Route path="/customer" component={Customer} />
              <Route path="/supplier" component={Supplier} />
              <Route path="/delivery" component={Delivery} />
              <Route path="/admin" component={AdminPart} />
              <Route path="/driver" component={Driver} />

              <Route path="/addcustomer" component={AddCustomer} />
              <Route path="/addsupplier" component={AddSupplier} />
              <Route path="/adddelivery" component={AddDelivery} />
              <Route path="/addadmin" component={AddAdmin} />
              <Route path="/adddriver" component={AddDriver} />

              <Route path="/editdriverinfo/:id" component={EditDriver} />
              <Route path="/editdeliveryinfo/:id" component={EditDelivery} />
              <Route path="/editsupplierinfo/:id" component={EditSupplier} />
              <Route path="/editadmininfo/:id" component={EditAdmin} />


              <Route path="/addcar" component={AddVehicle} />
              <Route path="/carlist" component={VehicleList} />
              <Route path="/addcolor" component={AddColor} />
              <Route path="/colorlist" component={ColorList} />

              <Route path="/restaurantproduct" component={RestaurantProduct} />
              <Route path="/superyProducts" component={SuperyProducts} />
              <Route path="/foodslist" component={ResturansFood} />
              <Route path="/supermarketproduct" component={SupermarketProduct}/>
              <Route path="/assignproducttorestaurant" component={AssignProductToRestaurant}/>
              <Route path="/assignproducttosupermarket" component={AssignProductToSupermarket}/>

              <Route path="/restaurantcomment" component={RestaurantComment} />
              <Route path="/supermarketcomment" component={SuperMarketComment} />
              <Route path="/productrestaurantcomment" component={ProductRestaurantComment}/>
              <Route path="/productsupermarketcomment" component={ProductSupermarketComment}/>
              <Route path="/editproductbasesupplier" component={EditProductBaseSupplier}/>

              <Route path="/suppliersupport" component={SupplierSupport} />
              <Route path="/usersupport" component={UserSupport} />
              <Route path="/deliverysupport" component={DeliverySupport} />

              <Route path="/editaddress/:id" component={EditAddress} />
              <Route path="/editproduct/:id" component={EditSuperyProduct} />
              {/* <Route path="/editdeliveryinfo/:id" component={EditDeliveryInfo}/>
              <Route path="/editsupplierinfo/:id" component={EditSupplierInfo}/>
              <Route path="/editadmininfo/:id" component={EditAdminInfo}/> */}

              <Route path="/productdiscount" component={OneProductDiscount}/>
              <Route path="/allproductdiscount" component={AllDiscountProduct}/>
              <Route path="/categorydiscount" component={OneCategoryDiscount}/>

              <Route path="/creatediscountcode" component={CreateDiscountCode}/>
              <Route path="/createpublicdiscountcode" component={createpublicdiscountcode}/>
              <Route path="/createprivatediscountcode" component={createPrivateDiscountCode}/>
              <Route path="/privatediscountcodelist" component={PrivateDiscountList}/>
              <Route path="/publicdiscountcodelist" component={PublicDiscountList}/>
              <Route path="/productdiscounted" component={OneProductDiscountList}/>
              <Route path="/allproductdiscounted" component={AllProductDiscountList}/>
              <Route path="/categorydiscounted" component={OneCategoryDiscountList}/>
              <Route path="/addnewcategory" component={AddNewCategory} />
              <Route path="/editproductscategory" component={EditProductCategory} />
              <Route path="/firstcategorylist" component={LevelOneCategoryListPart} />
              <Route path="/secondcategorylist" component={LevelTwoCategoryListPart} />
              <Route path="/addresturantcategory" component={AddResturantCategory} />
              <Route path="/resturantcategorylist" component={ResturantCategoryList} />

              <Route path="/deliverycost" component={DeliverCost} />

              <Route path="/addbrand" component={AddBrand} />
              <Route path="/brandlist" component={BrandList} />

              <Route path="/outcome" component={OutCome} />
              <Route path="/income" component={InCome} />
              
              <Route path="/newpayreq" component={newPayRequest} />
              <Route path="/payedreq" component={payedRequestList} />
              <Route path="/failedpay" component={failedPay} />



              {/* **********************  buy part ********************** */}
              <Route path="/activeorderbuy" component={ActiveOrderPeyk} />
              <Route path="/allorderbuy" component={AllOrderPeyk} />
              <Route path="/acceptedordersupplierbuy" component={AcceptedOrderSupplierPeyk}/>
              <Route path="/preparedorderbuy" component={OrdersPreparedPeyk} />
              <Route path="/acceptedorderdeliverybuy" component={AcceptedOrderDeliveryPeyk}/>
              <Route path="/ordersdeliveredbuy" component={OrdersDeliveredPeyk} />
              <Route path="/intelegentvoiceorder" component={IntelegentVoiceOrder} />

              {/* **********************  taxi part ********************** */}
              <Route path="/alltaxireq" component={AllTaxiRequest} />
              {/* **********************  delivery part ********************** */}
              <Route path="/alldeliveryreq" component={AllDeliveryRequest} />
              {/* **********************  factor part ********************** */}
              <Route path="/addfactor" component={AddFactor} />
              <Route path="/factorlist" component={FactorList} />
              {/* **********************  baresthelp part ********************** */}
              <Route path="/baresthelplist" component={BarestHelpList} />
            </Switch>
          )}
        />
      </Switch>
      <ToastContainer limit={3} />
    </Router>
  );
}

export default App;
